import {
  Directive,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from "@angular/core";
import { CeloFileUploader } from "./celo-file-uploader";

/** Turns the host element into a drag-and-drop zone for the bound uploader. */
@Directive({
  selector: "[celoFileDrop]",
  standalone: false,
})
export class CeloFileDropDirective {
  @Input() uploader!: CeloFileUploader;

  /** Emits true while files are dragged over the zone, false otherwise. */
  @Output() fileOver = new EventEmitter<boolean>();

  /** Emits the dropped files after they are added to the uploader queue. */
  @Output() filesDropped = new EventEmitter<FileList>();

  @HostListener("dragover", ["$event"])
  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.fileOver.emit(true);
  }

  @HostListener("dragleave", ["$event"])
  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.fileOver.emit(false);
  }

  @HostListener("drop", ["$event"])
  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.fileOver.emit(false);

    const files = event.dataTransfer?.files;
    if (!this.uploader || !files?.length) {
      return;
    }
    this.uploader.addFiles(files);
    this.filesDropped.emit(files);
  }
}
